// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '../Message';
import { DirectAlgorithmMessageBase } from './DirectAlgorithmMessageBase';
export class DirectAlgorithmHistoricalGainersLosersTopsMessage extends DirectAlgorithmMessageBase {
    constructor() {
        super(Message.CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE);
        this.GainersLosersData = [];
    }
}
